"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadShowJS = function loadShowJS(scriptSrc, callback) {
  var existingScript = document.getElementById('showJS');

  if (!existingScript) {
    var script = document.createElement('script');
    script.id = 'showJS';
    script.src = scriptSrc;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    script.onload = function () {
      callback();
    };
  }

  if (existingScript && callback) callback();
};

var _default = loadShowJS;
exports["default"] = _default;